import React from "react";
import './status.scss';
import {Icon} from '@ui-kit';

const Status = ({
    size      = 'md',
    className = '',
    ico       = '',
    user = {},
}) => {
    const classes = ['status__container', size,  ...className.split(' ')];
    const { patronStatus, idTier, patreonEmail } = user;

    if (!patreonEmail) {
        classes.push("checking");
    }

    if (patronStatus === 'former_patron') {
        classes.push("former");
    } else if (idTier.length && patronStatus === 'active_patron') {
        classes.push("active");
    } else if (patronStatus === 'declined_patron') {
        classes.push("declined");
    } else if (!patronStatus && patreonEmail) {
        classes.push("follower");
    }

    if (ico) {
        return <Icon src={ico} alt="ava-ico"/>
    }

    return (
        <div className={classes.join(' ')}></div>
    )
}

export default Status;